export type EntrepriseLike = {
  nom?: string;
  soumisATVA?: boolean;
  tauxTVA?: number;
  seeded_fields?: string[];
};

// Détection des champs critiques seedés (nom, soumisATVA, tauxTVA si soumis)
export function hasSeededCriticalEntreprise(
  seededFields: string[] | undefined,
  entreprise: EntrepriseLike | undefined
): boolean {
  const seeds = seededFields || entreprise?.seeded_fields || [];
  if (!seeds.length) return false;
  const soumis = entreprise?.soumisATVA ?? true;
  const hasNom = seeds.includes('nom');
  const hasSoumis = seeds.includes('soumisATVA');
  const hasTaux = soumis && seeds.includes('tauxTVA');
  return hasNom || hasSoumis || hasTaux;
}

export function getCriticalEntrepriseFieldsStatus(
  seededFields: string[] | undefined,
  entreprise: EntrepriseLike | undefined
) {
  const seeds = seededFields || entreprise?.seeded_fields || [];
  const soumis = entreprise?.soumisATVA ?? true;
  return [
    {
      key: 'nom',
      label: "Nom de l'entreprise",
      value: entreprise?.nom ?? '',
      seeded: seeds.includes('nom'),
    },
    {
      key: 'soumisATVA',
      label: 'Soumis à la TVA',
      value: (entreprise?.soumisATVA ?? true) ? 'Oui' : 'Non',
      seeded: seeds.includes('soumisATVA'),
    },
    {
      key: 'tauxTVA',
      label: 'Taux de TVA applicable (%)',
      value: soumis ? (entreprise?.tauxTVA ?? 20) : 'N/A',
      seeded: soumis && seeds.includes('tauxTVA'),
    },
  ];
}
